<script>
  import TwoColumns from "../TwoColumns.svelte";
  import { link } from "../../../core";
  import SchedulePanel from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import type { ISchedulePanel } from "../../blocks/schedule-panel/SchedulePanel.svelte";
  import type { IPageData } from "../../../core/types";

  interface IArticlePage extends IPageData {
    backButton: {
      parentName: string;
      parentUrl: string;
    };
    schedulePanel: ISchedulePanel;
  }

  export let data: IArticlePage;
</script>

<TwoColumns>
  {#if data?.backButton}
    <div class="back-button g-centered">
      <a use:link class="back-button__link" href={data.backButton.parentUrl}>
        <svg class="icon" width="15" height="16" aria-label="back">
          <use xlink:href="#arrow-left" />
        </svg>
        <span>{data.backButton.parentName}</span>
      </a>
    </div>
  {/if}

  <slot />

  <div slot="aside">
    <SchedulePanel schedulePanel={data.schedulePanel} />
  </div>
</TwoColumns>

<style lang="scss">
  .back-button {
    margin-bottom: 40px;

    &__link {
      display: flex;
      align-items: center;
      column-gap: 8px;
      color: $key-color;
      font-weight: 900;
    }
  }
</style>
